/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ContractDocumentsControllerUpdateMutationRequest, ContractDocumentsControllerUpdateMutationResponse, ContractDocumentsControllerUpdatePathParams, ContractDocumentsControllerUpdate400, ContractDocumentsControllerUpdate401, ContractDocumentsControllerUpdate403, ContractDocumentsControllerUpdate404 } from "../../models/contractDocumentsController/ContractDocumentsControllerUpdate";

function getContractDocumentsControllerUpdateUrl(id: ContractDocumentsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/contract-documents/${id}` as const }  
  return res
}

/**
 * @summary Re-point a contract document at a different file
 * {@link /api/v1/contract-documents/:id}
 */
export async function contractDocumentsControllerUpdate(id: ContractDocumentsControllerUpdatePathParams["id"], data?: ContractDocumentsControllerUpdateMutationRequest, config: Partial<RequestConfig<ContractDocumentsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ContractDocumentsControllerUpdateMutationResponse, ResponseErrorConfig<ContractDocumentsControllerUpdate400 | ContractDocumentsControllerUpdate401 | ContractDocumentsControllerUpdate403 | ContractDocumentsControllerUpdate404>, ContractDocumentsControllerUpdateMutationRequest>({ method : "PATCH", url : getContractDocumentsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}